import React from 'react';
import { motion } from 'framer-motion';
export function ProblemSection() {
  return <section className="py-20 lg:py-28 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto" data-id="element-547">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center" data-id="element-548">
        <motion.div initial={{
        opacity: 0,
        x: -20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="lg:col-span-7" data-id="element-549">
          <div className="mb-6" data-id="element-550">
            <span className="text-xs font-semibold text-navy-light uppercase tracking-[0.2em]" data-id="element-551">
              Why This Matters
            </span>
          </div>

          <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-ink-dark leading-tight mb-8 text-balance" data-id="element-552">
            Modern societies demand judgment, but rarely build it.
          </h2>

          <div className="space-y-6 text-lg text-ink-muted leading-relaxed" data-id="element-553">
            <p data-id="element-554">
              People are expected to evaluate information, resist manipulation,
              regulate emotion under stress, plan for the future, cooperate
              across differences, and choose leaders capable of governing
              complexity.
            </p>
            <p data-id="element-555">
              Most systems still focus on credentials, short-term outputs, and
              reactive crisis management instead of deliberately developing
              judgment, resilience, and responsibility.
            </p>
            <p className="font-medium text-navy text-xl pt-4 border-t border-line mt-8" data-id="element-556">
              SyNeural was built to address that gap.
            </p>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="lg:col-span-5 relative h-full min-h-[300px] flex items-center justify-center" data-id="element-557">
          <svg viewBox="0 0 300 300" className="w-full h-full max-w-sm" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-558">
            <defs data-id="element-559">
              <pattern id="grid" width="30" height="30" patternUnits="userSpaceOnUse" data-id="element-560">
                <path d="M 30 0 L 0 0 0 30" fill="none" stroke="#D9E2EC" strokeWidth="0.5" data-id="element-561" />
              </pattern>
            </defs>
            <rect width="300" height="300" fill="url(#grid)" data-id="element-562" />

            {/* Abstract representation of complexity/noise vs clarity */}
            <g className="opacity-70" data-id="element-563">
              {/* Noise/Overload */}
              <circle cx="80" cy="80" r="40" stroke="#5B6675" strokeWidth="1" strokeDasharray="2 2" data-id="element-564" />
              <circle cx="100" cy="120" r="30" stroke="#5B6675" strokeWidth="1" data-id="element-565" />
              <circle cx="60" cy="140" r="25" stroke="#5B6675" strokeWidth="1" strokeDasharray="1 3" data-id="element-566" />
              <path d="M40 80 L120 140 M60 140 L100 80" stroke="#5B6675" strokeWidth="0.5" data-id="element-567" />

              {/* Filter/Structure */}
              <path d="M150 50 L150 250" stroke="#245B8F" strokeWidth="2" strokeDasharray="4 4" data-id="element-568" />

              {/* Clarity/Alignment */}
              <rect x="190" y="100" width="60" height="60" rx="4" fill="#FFFFFF" stroke="#123B5D" strokeWidth="1.5" data-id="element-569" />
              <circle cx="220" cy="130" r="8" fill="#2E8C88" data-id="element-570" />
              <path d="M220 100 L220 160 M190 130 L250 130" stroke="#D9E2EC" strokeWidth="1" data-id="element-571" />
            </g>
          </svg>
        </motion.div>
      </div>
    </section>;
}